export default {
      id: "i-logo-new-usage",
      viewBox: "0 0 140 41",
      url: __webpack_public_path__ + "img/sprite.svg#i-logo-new",
      toString: function () {
        return this.url;
      }
    }